export const WIDGET_GET_PATIENTS_WITH_NEW_NOTES = 'widget-patients-with-new-notes';
export const WIDGET_GET_PATIENTS_WITH_NEW_NOTES_RESULT = `${WIDGET_GET_PATIENTS_WITH_NEW_NOTES}/result`;
export const WIDGET_GET_PATIENTS_WITH_NEW_NOTES_ERROR = `${WIDGET_GET_PATIENTS_WITH_NEW_NOTES}/error`;
